const style = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  item: {
    flexBasis: '24%',
  },
};

export default style;
